<template>
    <li>
        <a
            class="tab textcenter paddingtop10 paddingbottom10 factab"
            :class="activeTab ? 'active ' + width : width"
            v-on:click="$emit('click')"
            >{{ title ? title : 'Provide a title' }}</a
        >
    </li>
</template>

<script>
export default {
    name: 'Tab',
    props: {
        width: String,
        title: String,
        activeTab: Boolean,
        method: { type: Function },
    },
}
</script>

<style scoped>
.tab {
    border: white;
    font-weight: bold;
    width: 20%;
    float: left;
}
.active,
.active::after,
.active:hover,
a:hover::after,
a:hover {
    text-decoration: none !important;
    border-top-color: #37b5d3;
    border-bottom-color: white;
    border-left-color: white;
    border-right-color: white;

    background: #37b5d3 !important;
    color: white !important;
}
@media screen and (max-width: 900px) {
    .tab {
        width: auto;
        padding: 8px;
        font-size: 11px;
    }
}
</style>
